
const actions = {
  fetchData: async (context, payload) => {
    let data = [1, 2, 3]
    context.commit('setData', data)
  },
  fetchMessage: (context, payload) => {
    context.commit('setMessage', 'Welcome to Your Vue.js App')
  }
}

export default actions
